import { FC } from 'react';

const MESSAGES = {
  dragDrop: 'Drag & drop files or ',
  browseFiles: 'browse files',
  maxFileSize: 'Upload your first party data file - Max file size 20MB',
  fileUploaded: 'File Uploaded',
};

export const DragDropMessage: FC = () => (
  <>
    <span className='mt-2 text-[#1E1E1E] text-sm font-medium'>
      {MESSAGES.dragDrop}
      <span className='underline'>{MESSAGES.browseFiles}</span>
    </span>
    <div className='text-[#8E8F94] text-xs font-normal'>{MESSAGES.maxFileSize}</div>
  </>
);

export const FileUploadedMessage: FC = () => (
  <span className='text-center text-lg text-[#1E1E1E] font-semibold justify-between mt-2'>{MESSAGES.fileUploaded}</span>
);
